import { CROSS_SITE_PARAMS, DASHBOARD_PARAM_DEFAULTS, REGULAR_TEST_RESULTS_PARAMS } from './constants';

// Angular's router already decodes query params once; copy them verbatim so
// values stay byte-exact for QuickSight (labels with trailing spaces, test
// names containing % signs). A second decodeURIComponent would throw on a bare
// % and corrupt literal %xx sequences.
export function extractDashboardParameters(queryParams: Record<string, string>): Record<string, string> {
  const parameters: Record<string, string> = { ...queryParams };

  const hasCrossSiteTest =
    parameters.CrossSitetestTestName && parameters.CrossSitetestTestName !== DASHBOARD_PARAM_DEFAULTS.NO_FILTER;
  const hasRegularTest = parameters.testName && parameters.testName !== DASHBOARD_PARAM_DEFAULTS.NO_FILTER;

  if (hasCrossSiteTest && hasRegularTest) {
    const hasCrossSiteParams = !!(
      parameters.CrossSiteMainKPI ||
      parameters.CrossSiteKPILiftMethod ||
      parameters.CrossSitecalculateImpactFor
    );

    if (hasCrossSiteParams) {
      REGULAR_TEST_RESULTS_PARAMS.forEach((param) => {
        delete parameters[param];
      });
    } else {
      CROSS_SITE_PARAMS.forEach((param) => {
        delete parameters[param];
      });
    }
  }

  return parameters;
}
